export default __webpack_public_path__ + "static/media/postcard.ba472ce8.svg";